import React from "react";
import { Typewriter } from "react-simple-typewriter";
import { Link } from "react-router-dom";
import dp from "../../Images/dp.jpg";
import Particles from "react-tsparticles";
import particlesConfig from "../../particles-config/config";
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import "./Home.css";

function Home() {
  const particlesInit = (main) => {
    console.log(main);

    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
  };

  const particlesLoaded = (container) => {
    console.log(container);
  };

 
  return (
    <div className="home-content">

      <Particles
        className="part"
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={particlesConfig}
      />

        <Zoom>
        <div className="left-cont">          
            <img src={dp} className="photo" alt="dp" />
        </div>
        </Zoom>
      

      <div className="right-cont">
        {/* <p style={{fontSize: '100px' ,color:'#0961e6', marginLeft:'10px'}}>Hi</p> */}
        <Fade top>
          <h1 style={{ fontSize:"45px" }}>
            Hi, My name is 
            <span
              style={{ color: "#02ffdc", fontWeight: "bold", marginLeft: "10px" }}
            >
              <Typewriter
                // loop
                cursor
                cursorStyle=""
                typeSpeed={70}
                deleteSpeed={80}
                delaySpeed={1200}
                words={["Ashish Kumar"]}
              />
            </span>
            <br/>
            I'm a
            <span
              style={{ color: "#00a1ff", fontWeight: "bold", marginLeft: "10px" }}
            >
              <Typewriter
                loop
                cursor
                cursorStyle="|"
                typeSpeed={70}
                deleteSpeed={80}
                delaySpeed={1200}
                words={["Programmer.", "Developer.", "Learner.", "Gamer."]}
              />
            </span>
          </h1>
        </Fade>
        <br />

        <Fade bottom>
          <Link to="/about" style={{ fontSize:"30px", color:"#b856ea", fontWeight: "bold", marginTop:"2rem", textDecoration:"none"}}>More About Me ➤</Link>
        </Fade>
      </div>
    </div>
  );
}

export default Home;
